import  {useEffect } from "react";
import styled from "styled-components";
import { FlexContainer, Page,GradientText } from "../components/styled";
import PvpBackgroundtop from "../assets/images/background/pvpbackgroundtop.png";
import PvpBackgroundbottom from "../assets/images/background/pvpbackgroundbottom.png";
import PvpMockMonster from "../assets/images/pvpmockmonster.png";
import Pvprulesbackground from "../assets/images/background/pvprulesbackground.png";
import PvprulesTitle from "../assets/images/pvpulestitle.png";
import {useBottomSheet} from "../context/BottomSheetContext";
import JoinPvpModalContent from "../components/joinPvpModalContent";
import { useState } from "react";
import WaitingPlayerImage from "../assets/images/waitingplayer.gif";
import { useNavigate } from "react-router-dom";
import { pulse } from "../components/styled/animations";
import { useSocket } from "../context/SocketContext";
import { BattleEvents } from "../constants";
import { getPvpSeason } from "../service/main/api";
import { useBattle } from "../context/BattleContext";
import { useLoading } from "../context/LoadingContext";
import { getUserLotteryTickets } from "../service/main/api";
import { useToaster } from "../hooks/useToaster";
import { spin } from "../components/styled/animations";
import ReactMarkdown from "react-markdown";
import { useUserContext } from "../context/UserContext";
const Pvp = () => {
    const {openSheet,closeSheet} = useBottomSheet();
    const [showWaiting, setShowWaiting] = useState(false);
    const {isConnected,socket,connectSocket ,disconnectSocket}= useSocket();
    const [buttonActive, setButtonActive] = useState(false);
    const {setSeason} = useBattle();
    const [pvpSeason, setPvpSeason] = useState(null);
    const { user,energyItems } = useUserContext();
    const [energyFlesks, setEnergyFlesks] = useState(0);
    const { setIsLoading } = useLoading();
    const { showToaster } = useToaster();
    const [userLuackyPassCount, setUserLuckyPassCount] = useState(0);
    const fetchPvpSeason = async () => {
        try {
            const response = await getPvpSeason();
            if(response.success === false){
                alert("Error fetching PVP season data:", response.message);
                return;
            }
            setPvpSeason(response.data);
            setSeason(response.data);
            if(response.data.aditionalItem){
                await getLuckyPass();
            }
        } catch (error) {
            console.error("Error fetching PVP season data:", error);
        }
    };
    const getEnergyFlesks = async () => {
        setIsLoading(true);
        let energyFleskId = energyItems.find(item => item.name === "Energy Flesk")?._id;
        const data = user.energyItems ? user.energyItems[energyFleskId] || 0 : 0;
        setEnergyFlesks(data);
        setIsLoading(false);
    }
    const getLuckyPass = async () => {
        try {
             setIsLoading(true);
            const response = await getUserLotteryTickets();
            if(response.success === false){
                alert("Error fetching lucky pass data:", response.message);
                return;
            }
            const unusedTickets = response.data.filter(ticket => !ticket.used);
            setUserLuckyPassCount(unusedTickets.length);
        } catch (error) {
            console.error("Error fetching lucky pass data:", error);
        }
        finally {
            setIsLoading(false);
        }
    }
    const navigate = useNavigate();
    const handleJoinPvp = () => {
        if(!buttonActive){
          showToaster({ type: "info", message: "Season not started, please wait until the season starts." });
          return;
        }
        openSheet({
            content: <JoinPvpModalContent aditionalItem={pvpSeason.aditionalItem} onDone={joinPvp} onClose={closeSheet} price={pvpSeason.ticket.count} />,

        });
    };
    const joinPvp = () => {
       if(!buttonActive) return;
       setButtonActive(false);
       closeSheet();
       if(energyFlesks < 30){
        showToaster({ type: "error", message: "You need at least 30 energy flesks to join PVP" });
        setButtonActive(true);
        return;
       }
       if(pvpSeason.aditionalItem && userLuackyPassCount < pvpSeason.aditionalItem.count){
        showToaster({ type: "error", message: `You need at least ${pvpSeason.aditionalItem.count} lucky pass to join PVP` });
        setButtonActive(true);
        return;
       }
       handleSocketConnection();
    }
    const handleSocketConnection = () => {
        if (!isConnected) {
            connectSocket();
        }else{
            disconnectSocket();
            connectSocket();
        }
    }
    useEffect(() => {
        fetchPvpSeason();
        getEnergyFlesks();
    }, []);
    useEffect(() => {
        if (socket && isConnected) {
            socket.on(BattleEvents.QUEUED, () => {
                setShowWaiting(true);
            });
            socket.on(BattleEvents.READY, () => {
                setShowWaiting(false);
                navigate("/beforebattle");
            });
        }
    }, [socket,isConnected]);
    return (
        <Page>
        {showWaiting && (
            <Waitincontainer>
                <FlexContainer flexdirection="column">
                    <img src={WaitingPlayerImage} style={{width:"100%",height:"auto"}} />
                    <GradientText>Waitin for player...</GradientText>
                </FlexContainer>
            </Waitincontainer>
        )}
        <PvpBackgroundTop src={PvpBackgroundtop} />
        <PvpBackgroundBottom src={PvpBackgroundbottom} />
        <PvpMainContainer>
            <PvpMonster src={PvpMockMonster} />
            <PvpRulescontainer>
                {!buttonActive && showWaiting &&
                    <Spinner/>
                }
               <Joinbutton onClick={handleJoinPvp} src={PvprulesTitle} alt="join" />
                <ContentContainer>
                <img src={Pvprulesbackground} style={{ width: "100%", height: "100%",maxWidth:"291px"
                }} />
                <MarkdownContainer>
                 <ReactMarkdown>
                {pvpSeason ? pvpSeason.description : "Loading PVP season description..."}
                </ReactMarkdown>
                </MarkdownContainer>
                </ContentContainer>
            </PvpRulescontainer>
           
        </PvpMainContainer>
        </Page>
    );
}
const Spinner = styled.div`
  border: 4px solid ${(props) => props.theme.colors.light || "#f3f3f3"};
  border-top: 4px solid ${(props) => props.theme.colors.primary || "#3498db"};
  border-radius: 50%;
  width: ${(props) => props.size || "50px"};
  height: ${(props) => props.size || "50px"};
  animation: ${spin} 1s linear infinite;
  position: absolute;
  z-index: 10;
`;
const PvpMainContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-end;

`;
const PvpMonster = styled.img`
    position: absolute;
    top: 10%;
    left: 20%;
`

const PvpBackgroundTop = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 42%;
`;
const PvpBackgroundBottom = styled.img`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 58%;
`;
const PvpRulescontainer = styled.div`
    position: relative;
    width: 100%;
    max-width: 291px;
    display: flex;
    justify-content: center;
    padding: 34px 16px 0px;
    margin-bottom    : 10%;
`;
const ContentContainer = styled.div`
    width: 100%;
    text-align: center;
    z-index: 2;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`
const Waitincontainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
    img{
        max-width: 60%;
    }
    span{
        font-size: 20px;
        font-weight: 700;
        margin-top: -24px;
    }
`
const Joinbutton = styled.img`
    animation: ${pulse} 2s infinite;
    position: absolute;
    top: 0;
    width: 214px;
    height: auto;
    cursor: pointer;
    z-index: 3;
    &:hover {
        transform: scale(1.05);
    }
`
const MarkdownContainer = styled.div`
    position: absolute;
    padding:20px;
    font-size: 12px;
// const PvpRulesTitle = styled.img`
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     background-image: url(${PvprulesTitle});
//     background-size: cover;
//     background-position: center;
// `;
export default Pvp;